import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ConfirmToggleButtonProps {
    label: string;
    pendingLabel?: string;
    isOn: boolean;
    isPending?: boolean;
    disabled?: boolean;
    onClick?: () => void;
}

export const ConfirmToggleButton = ({
    label,
    pendingLabel,
    isOn,
    isPending = false,
    disabled = false,
    onClick,
}: ConfirmToggleButtonProps) => (
    <button
        type="button"
        className={`ff-wires__confirm-btn${isOn ? ' is-on' : ''}`}
        disabled={!onClick || disabled || isPending}
        onClick={onClick}>
        {isOn && <FontAwesomeIcon icon={faCheck} />}
        {isPending && pendingLabel ? pendingLabel : label}
    </button>
);
